const openEnded = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "open-ended",
    items: [
      { id: "q1", question: "プロンプトのテキスト 1", answers: [], image: null },
      { id: "q2", question: "プロンプトのテキスト 2", answers: [], image: null },
      { id: "q3", question: "プロンプトのテキスト 3", answers: [], image: null },
      { id: "q4", question: "プロンプトのテキスト 4", answers: [], image: null },
      { id: "q5", question: "プロンプトのテキスト 5", answers: [], image: null },
    ],
  },
  botId: "nualang.open-ended.0.0.1",
  botName: "open_ended",
  description: "open_ended_desc",
  difficulty: "ALL",
  learnLang: "japanese",
  name: "",
  botAvatar: "",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-comment-dots?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# ようこそ
  
  「こんにちは」と言って始めましょう。`,
  voice: "",
  versionQuestion: "このテンプレートには何個のプロンプトが欲しいですか？",
};

export default openEnded;
